export default __webpack_public_path__ + "static/media/new-service-icon.a285f1b3.svg";